'use client'

import { Badge, Icon } from '@vinted/web-ui'
import { IconType } from '@vinted/web-ui/dist/types/lib/Icon/Icon'

import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

type Props = {
  id: string
  iconType: IconType
  content: string | null
  isVisible: boolean
}

const DiscountBadge = ({ id, iconType, content, isVisible }: Props) => {
  const isDarkBadgeTestOn = useAbTest('discount_badge_ui_v2')?.variant === 'on'

  return (
    isVisible && (
      <Badge
        testId={`${id}-discount-badge`}
        theme="warning"
        styling={isDarkBadgeTestOn ? Badge.Styling.Filled : Badge.Styling.Light}
        icon={
          <Icon
            name={iconType}
            color={isDarkBadgeTestOn ? Icon.Color.GreyscaleLevel7 : Icon.Color.WarningDark}
            aria={{
              'aria-hidden': 'true',
            }}
          />
        }
        content={content}
      />
    )
  )
}

export default DiscountBadge
